import header from "./header.module.css";
import WpuLogo from "../../styles/svg/wpu/wpuLogo.svg";

const Header = () => {
  return (
    <div className={header.headercontainer}>
      <div className={header.titleWrapper}>
        <h1 className={header.h1}>الجامعة الوطنية الخاصة</h1>
      </div>
      <div className={header.orglogoWrapper}>
        <img className={header.wpulogo} src={WpuLogo} alt="WPU LOGO" />
      </div>
    </div>
  );
};
export default Header;
